import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import * as constant from './../../shared/constants/constants';
import { NavigationService } from '../services/navigation.service';
import { ResponsiveService } from '../responsive/responsive.service';
import { TranslateService } from '@ngx-translate/core';
import { UtilService } from '../services/util.service';
import { MsalService } from '@azure/msal-angular';
import { StorageService } from '../services/storage.service';
import { NotificationService } from '../services/notification.service';
import { localStorageKeys, role_name } from 'src/app/core/enum';

@Component({
  selector: 'app-navigation-bar',
  templateUrl: './navigation-bar.component.html',
  styleUrls: ['./navigation-bar.component.scss'],
})
export class NavigationBarComponent implements OnInit {
  /** Navigatio Menu Data Variable */
  menu_data: MenuItem[] | any;

  /** Selected Navigation Item Varaible */
  selected_menu_item:any ={}

  /** Navigation Bar Open Variable */
  navigation_open: boolean = false; 

  /** User Name Variable */
  user_name: any;
  role_name: any;

  notification_available: any = false;
  notification_visible: any = true;

  constructor(
    private router: Router,
    public navigationService: NavigationService,
    public responsiveService: ResponsiveService,
    public utilService: UtilService,
    public msalService: MsalService,
    private storageService: StorageService,
    private notificationService: NotificationService
  ) { 
    this.notificationService.triggerNotificationSymbol.subscribe((value:any)=>{
      this.notification_available = value;
     })
  }


  async ngOnInit() {
    await this.getMenuData();
    this.navigationService.navigation_open.subscribe((value: any) => {
      this.navigation_open = value;
      this.selected_menu_item.expanded = false
    })
    this.tooltipShow()
  }

  /** Click function for Navigation Items */
  navigationIconOnClick(label:any){
    if(label.item.items && label.item.items.length>0 && !label.item.expanded){
      this.navigation_open = true
      this.selected_menu_item = label.item
    }
    else if(label.item.items && label.item.items.length>0 && !label.item.expanded){
      this.selected_menu_item ={}
    }
    this.tooltipShow();
  }

  /** Api call function for Navigation Data */
  async getMenuData() {
    this.utilService.navigation_trigger.subscribe(async (value)=>{
      if(value)
      {
        this.data();
      }
    })
  }

  async menuDto(){
    const role_id = await this.storageService.get(constant.storage_keys.role_id)
    return {
      role_id: role_id
    }
  }

  /** Handle Navigation Data */
  async handleMenuData(response: any) {
    this.utilService.setNavigationCodes(response)
    this.menu_data = this.navigationService.convertMenuData(response, this.navigationIconOnClick.bind(this))
    this.user_name = await this.storageService.get(constant.storage_keys.user_name)
    let role_id  = await this.storageService.get(constant.storage_keys.role_id);
    this.role_name = role_name[role_id];
  }

  /** Redirect to Home Page */
  homePage(){
    this.router.navigate([constant.navigation.dashboard])
  }

  /** For Checking SideBar Visibility */
  checkSideBarVisiblity(){
    if(this.router.url == constant.navigation.dashboard){
      return false
    }
    // this.data();
    return true
  }

  async data(){
    this.handleMenuData(await this.storageService.get(localStorageKeys.menu))
  }

    /** Logout from the application */
    logout() {
     this.utilService.logout();
    }

    /*
     * open notification panel
     */
    notificationOpen(){
      this.utilService.notification_visible.next(this.notification_visible)
    }

  tooltipShow() {
    document.body.classList.toggle('tooltipShow', !this.navigation_open);
  }

}